import Vue from "vue";
import VueRouter from "vue-router";
import AppFlow from "../AppFlow";

//Step 0
import Home from "../views/Home.vue";
import Upgrade from "../views/upgrade/Upgrade.vue";
import UpgradeCompleted from "../views/upgrade/UpgradeCompleted.vue";

//Step 1
import Addresses from "../views/step_01/Addresses.vue";

//Step 2
import TitolareEffettivo from "../views/step_02/TitolareEffettivo.vue";
import Gianos from "../views/step_02/Gianos.vue";
import ScopoRapporto from "../views/step_02/ScopoRapporto.vue";

//Step 3
import ConfirmCard from "../views/step_03/ConfirmCard.vue";
import CardDocumentation from "../views/step_03/CardDocumentation.vue";
import RequestCertificate from "../views/step_03/RequestCertificate.vue";

//Step 4
import CardSign from "../views/step_04/CardSign.vue";
import InfocertSign from "../views/step_04/InfocertSign.vue";
import ConfirmAccessCode from "../views/step_04/ConfirmAccessCode.vue";
import ConfirmMobileToken from "../views/step_04/ConfirmMobileToken.vue";

//Step 5
import RegistrationCompleted from "../views/step_05/RegistrationCompleted.vue";

/** MINOR FLOW */
import MinorCardDocumentation from "../views/steps_minor/MinorCardDocumentation.vue";
import MinorCardSign from "../views/steps_minor/MinorCardSign.vue";
import MinorConfirmMobileToken from "../views/steps_minor/MinorConfirmMobileToken.vue";
import MinorWaitingTutorConfirm from "../views/steps_minor/MinorWaitingTutorConfirm.vue";
import MinorRegistrationCompleted from "../views/steps_minor/MinorRegistrationCompleted.vue";

/** TUTOR FLOW */
import TutorSetType from "../views/steps_tutor/TutorSetType.vue";
import TutorCardDocumentation from "../views/steps_tutor/TutorCardDocumentation.vue";
import TutorRequestCertificate from "../views/steps_tutor/TutorRequestCertificate.vue";
import TutorCardSign from "../views/steps_tutor/TutorCardSign.vue";
import TutorInfocertSign from "../views/steps_tutor/TutorInfocertSign.vue";
import TutorConfirmAccessCode from "../views/steps_tutor/TutorConfirmAccessCode.vue";
import TutorConfirmMobileToken from "../views/steps_tutor/TutorConfirmMobileToken.vue";
import TutorRegistrationCompleted from "../views/steps_tutor/TutorRegistrationCompleted.vue";

Vue.use(VueRouter);

const stepData = {
  step0: {
    index: null,
    title: "Richiesta carta",
    progressPercentage: null
  },
  step1: {
    index: 1,
    title: "Dati personali",
    progressPercentage: 20
  },
  step2: {
    index: 2,
    title: "Adeguata verifica",
    progressPercentage: 50
  },
  step3: {
    index: 3,
    title: "Consenso privacy",
    progressPercentage: 75
  },
  step4: {
    index: 4,
    title: "Firma contratto",
    progressPercentage: 100
  },
  step0Upgrade: {
    index: null,
    title: "Richiesta carta fisica",
    progressPercentage: null
  },
  step1Upgrade: {
    index: null,
    title: "Richiesta carta fisica",
    progressPercentage: 100
  },
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    props: true,
    meta: {
      stepData: stepData.step0,
      appsflyer_event: "richiesta_carta_step0"
    }
  },
  {
    path: "/upgrade",
    name: "Upgrade",
    component: Upgrade,
    props: true,
    meta: {
      stepData: stepData.step0Upgrade,
      appsflyer_event: "richiesta_carta_step0c"
    }
  },
  {
    path: "/upgradeCompleted",
    name: "UpgradeCompleted",
    component: UpgradeCompleted,
    props: true,
    meta: {
      stepData: stepData.step1Upgrade,
      appsflyer_event: "richiesta_carta_step0c",
      userCantGoBack: true
    }
  },
  {
    path: "/addresses",
    name: "Addresses",
    component: Addresses,
    props: true,
    meta: {
      stepData: stepData.step1,
      appsflyer_event: "richiesta_carta_step1",
      userCantGoBack: true
    }
  },
  {
    path: "/upgradeAddress",
    name: "UpgradeAddresses",
    component: Addresses,
    props: true,
    meta: {
      stepData: stepData.step0Upgrade,
      appsflyer_event: "richiesta_carta_step1",
      userCantGoBack: true
    }
  },
  {
    path: "/titolareEffettivo",
    name: "TitolareEffettivo",
    component: TitolareEffettivo,
    props: true,
    meta: {
      appsflyer_event: "richiesta_carta_step2",
      stepData: stepData.step2
    }
  },
  {
    path: "/gianos",
    name: "Gianos",
    component: Gianos,
    props: true,
    meta: {
      appsflyer_event: "richiesta_carta_step3",
      stepData: stepData.step2
    }
  },
  {
    path: "/scopoRapporto",
    name: "ScopoRapporto",
    component: ScopoRapporto,
    props: true,
    meta: {
      appsflyer_event: "richiesta_carta_step4",
      stepData: stepData.step2
    }
  },
  {
    path: "/confirmCard",
    name: "ConfirmCard",
    component: ConfirmCard,
    props: true,
    meta: {
      appsflyer_event: "richiesta_carta_step4_b",
      stepData: stepData.step3
    }
  },
  {
    path: "/cardDocumentation",
    name: "CardDocumentation",
    component: CardDocumentation,
    props: true,
    meta: {
      appsflyer_event: "richiesta_carta_step5",
      stepData: stepData.step3
    }
  },
  {
    path: "/requestCertificate",
    name: "RequestCertificate",
    component: RequestCertificate,
    props: true,
    meta: {
      appsflyer_event: "richiesta_carta_step6",
      stepData: stepData.step4
    }
  },
  {
    path: "/cardSign",
    name: "CardSign",
    component: CardSign,
    props: true,
    meta: {
      appsflyer_event: "richiesta_carta_step7",
      stepData: stepData.step4
    }
  },
  {
    path: "/infocertSign",
    name: "InfocertSign",
    component: InfocertSign,
    props: true,
    meta: {
      appsflyer_event: "richiesta_carta_step8",
      stepData: stepData.step4
    }
  },
  {
    path: "/confirmAccessCode",
    name: "ConfirmAccessCode",
    component: ConfirmAccessCode,
    props: true,
    meta: {
      appsflyer_event: "richiesta_carta_step9",
      stepData: stepData.step4
    }
  },
  {
    path: "/confirmMobileToken",
    name: "ConfirmMobileToken",
    component: ConfirmMobileToken,
    props: true,
    meta: {
      appsflyer_event: "richiesta_carta_step10",
      stepData: stepData.step4
    }
  },
  {
    path: "/registrationCompleted",
    name: "RegistrationCompleted",
    component: RegistrationCompleted,
    props: true,
    meta: {
      appsflyer_event: "richiesta_carta_stepcompleted",
      stepData: stepData.step4,
      userCantGoBack: true,
      hideHeader: true
    }
  },
  {
    path: "/minorCardDocumentation",
    name: "MinorCardDocumentation",
    component: MinorCardDocumentation,
    props: true,
    meta: {
      appsflyer_event: "richiesta_carta_step5",
      stepData: stepData.step4
    }
  },
  {
    path: "/minorCardSign",
    name: "MinorCardSign",
    component: MinorCardSign,
    props: true,
    meta: {
      appsflyer_event: "richiesta_carta_step7",
      stepData: stepData.step4
    }
  },
  {
    path: "/minorConfirmMobileToken",
    name: "MinorConfirmMobileToken",
    component: MinorConfirmMobileToken,
    props: true,
    meta: {
      appsflyer_event: "richiesta_carta_step10",
      stepData: stepData.step4
    }
  },
  {
    path: "/minorWaitingTutorConfirm",
    name: "MinorWaitingTutorConfirm",
    component: MinorWaitingTutorConfirm,
    props: true,
    meta: {
      appsflyer_event: "richiesta_carta_stepcompleted",
      stepData: stepData.step4,
      userCantGoBack: true,
      hideHeader: true
    }
  },
  {
    path: "/minorRegistrationCompleted",
    name: "MinorRegistrationCompleted",
    component: MinorRegistrationCompleted,
    props: true,
    meta: {
      stepData: stepData.step4,
      userCantGoBack: true,
      hideHeader: true
    }
  },
  {
    path: "/tutorSetType",
    name: "TutorSetType",
    component: TutorSetType,
    props: true,
    meta: {
      stepData: stepData.step2,
      userCantGoBack: true
    }
  },
  {
    path: "/tutorCardDocumentation",
    name: "TutorCardDocumentation",
    component: TutorCardDocumentation,
    props: true,
    meta: {
      stepData: stepData.step3,
      userCantGoBack: true
    }
  },
  {
    path: "/tutorRequestCertificate",
    name: "TutorRequestCertificate",
    component: TutorRequestCertificate,
    props: true,
    meta: {
      stepData: stepData.step3
    }
  },
  {
    path: "/tutorCardSign",
    name: "TutorCardSign",
    component: TutorCardSign,
    props: true,
    meta: {
      stepData: stepData.step4,
      hideHeader: true
    }
  },
  {
    path: "/tutorInfocertSign",
    name: "TutorInfocertSign",
    component: TutorInfocertSign,
    props: true,
    meta: {
      stepData: stepData.step4,
      hideHeader: true
    }
  },
  {
    path: "/tutorConfirmAccessCode",
    name: "TutorConfirmAccessCode",
    component: TutorConfirmAccessCode,
    props: true,
    meta: {
      stepData: stepData.step4
    }
  },
  {
    path: "/tutorConfirmMobileToken",
    name: "TutorConfirmMobileToken",
    component: TutorConfirmMobileToken,
    props: true,
    meta: {
      stepData: stepData.step4
    }
  },
  {
    path: "/tutorRegistrationCompleted",
    name: "TutorRegistrationCompleted",
    component: TutorRegistrationCompleted,
    props: true,
    meta: {
      stepData: stepData.step4,
      userCantGoBack: true,
      hideHeader: true
    }
  }
];

const router = new VueRouter({
  routes,
  //Setting the scroll always to the top of the page when changing routes
  scrollBehavior() {
    return new Promise(resolve => {
      //This is a fix because we need scroll in 'page' element, not window
      document.getElementsByClassName("page")[0].scrollTop = 0;
      resolve({ x: 0, y: 0 });
    });
  }
});

router.beforeEach((to, from, next) => {
  //Users coming from app should NOT be able to go back to the homepage
  //Instead, they sould go back to the app
  const userComesFromApp = sessionStorage.getItem("fromApp");
  const isBackToHomePage = to.name === "Home";
  if (userComesFromApp && isBackToHomePage) {
    window.vm.$root.$emit("appBack");
    return;
  }

  /**
   * We detect if user is going back with browser and check if he's allowed to.
   */
  const flattenStepsFlow = [].concat.apply([], AppFlow.stepsFlow);
  const indexFrom = flattenStepsFlow.indexOf(from.name);
  const indexTo = flattenStepsFlow.indexOf(to.name);
  const userIsGoingBack = indexTo < indexFrom;
  const userCantGoBack = from.meta.userCantGoBack;

  //Service navigation will ALWAYS be allowed
  const isServiceNavigation = to.params && to.params.SERVICE;

  if (userIsGoingBack && userCantGoBack && !isServiceNavigation) {
    window.vm.$root.$emit("confirmInterruptRegistration");
    next(false);
  } else next();
});

router.afterEach(to => {
  setTimeout(() => {
    if (window.vm) {
      window.vm.$root.$emit("viewLoaded", to);
    }
  }, 1000);
});

export default router;
